import { FormattedMessage } from 'components/@support';
import { jsx as _jsx } from "react/jsx-runtime";

const FeedbackUsername = _ref => {
  let {
    user,
    isSystem = false
  } = _ref;

  if (isSystem) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      id: "user.system_name"
    });
  }

  if (user) {
    return /*#__PURE__*/_jsx("a", {
      className: "u-disable-underline",
      href: user.profileUrl,
      children: user.login
    });
  }

  return /*#__PURE__*/_jsx(FormattedMessage, {
    id: "user.deleted_user"
  });
};

export default FeedbackUsername;